<div class="voucher-container border border-secondary mb-lg-4 position-relative">
  <div *ngIf="errorService.hasErrors()" @flyInOut class="status-container error position-absolute d-flex align-items-center">
    <span class="material-symbols-outlined me-2"> cancel </span>
    <p *ngFor="let error of errorService.errors">{{ error }}</p>
  </div>
  <div
    class="status-container position-absolute d-flex align-items-center"
    [ngClass]="{ success: successfulRedemption, error: !successfulRedemption && !isEmptyVoucher, 'empty': isEmptyVoucher }"
    *ngIf="redemptionResult"
    @flyInOut
  >
    @if(successfulRedemption){
    <span class="success material-symbols-outlined text-success me-2"> check_circle </span>
    } @else {
    <span class="error material-symbols-outlined text-danger me-2"> cancel </span>
    }
    <p>{{ redemptionResult }}</p>
  </div>
  <div class=" d-flex flex-column flex-lg-row justify-content-lg-between justify-content-center">
    <img
      *ifScreenSize="screenSize.Mobile"
      class="w-100 mb-3"
      [src]="'placeholders/vouchermobile.svg' | contentAssetImage"
      alt="Voucher"
    />
    <div>
      <div class="w-100 d-flex flex-column">
        <h5 class="mb-2 font-weight-bold text-white">
          {{ 'voucher.title' | translate }}
        </h5>
        <p>
          {{ 'voucher.description' | translate }}
        </p>
      </div>
      <div class="row align-items-center">
        <div class="col-lg-8 col-12">
          <span class="input-group">
            <input
              type="text"
              [(ngModel)]="voucherCode"
              placeholder="Enter Code"
              class="form-control text-start gloss ps-5 px-lg-0"
              (keyup.enter)="redeemVoucher()"
            />
          </span>
        </div>
        <div class="col-lg-4 col-12">
          <button
            class="btn btn-white fw-bold  py-0 voucher-btn"
            type="button"
            (click)="redeemVoucher()"
            [disabled]="disableButton"
          >
            {{ 'voucher.button' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg-4" *ifScreenSize="screenSize.Desktop">
      <img class="w-100 h-100" [src]="'placeholders/voucher.svg' | contentAssetImage" alt="Voucher" />
    </div>
  </div>
</div>
